import { render } from "./B2bTableMenuCoacsuRecibidos.vue?vue&type=template&id=05d85630&scoped=true&lang=pug"
import script from "./B2bTableMenuCoacsuRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuCoacsuRecibidos.vue?vue&type=script&lang=js"

import "./B2bTableMenuCoacsuRecibidos.vue?vue&type=style&index=0&id=05d85630&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d85630"]])

export default __exports__